<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm ngày nghỉ
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="pt-4">
          <v-row>
            <v-col cols="12" md="6">
              <DateIOSPicker
                label="Ngày"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
                dense
                :date.sync="date"
              />
            </v-col>
            <v-col class="d-flex align-center" cols="12">
              <span class="mr-2">Hình thức nghỉ</span>
              <RadioAbsentType :diligenceType="diligence.type" @change="type = $event" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="px-4" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import RadioAbsentType from './RadioAbsentType.vue'
import { get } from 'lodash'
import { Diligence } from '@/plugins/api'
import moment from 'moment'

export default {
  components: { RadioAbsentType, DateIOSPicker },
  data() {
    return {
      dialog: false,
      currentClass: null,
      diligence: {},
      type: '',
      date: ''
    }
  },
  props: {
    state: Boolean,
    student: Object
  },
  methods: {
    ...mapActions('Diligence', ['createDiligence']),
    async save() {
      if (!this.$refs.form.validate()) return
      const dateGte = moment(this.date)
        .startOf('day')
        .toISOString()
      const dateLte = moment(this.date)
        .endOf('day')
        .toISOString()
      const d = await Diligence.fetch({
        date_gte: dateGte,
        date_lte: dateLte,
        student: this.student.id,
        _limit: 1
      })
      if (d && d.length > 0) {
        this.$alert.error('Ngày nghỉ này đã tồn tại')
        return
      }
      try {
        this.$loading.active = true
        const data = {
          student: this.student.id,
          class: get(this.student.currentClass, 'id'),
          grade: this.student.grade.id,
          type: this.type,
          date: this.date
        }
        const d = await this.createDiligence(data)
        this.$emit('createdDiligence', d)
        this.dialog = false
        this.$alert.addSuccess()
        this.reset()
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    cancel() {
      this.dialog = false
      this.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
